<template>
  <form @submit.prevent="onSubmit">
    <!--    <vs-textarea label="Причина отмены" v-model="reason" />-->
    <app-textarea label="Произведенные действия" v-model="message" :danger="!!error" :danger-text="error" />
    <div class="text-center mt-4">
      <app-button>Завершить</app-button>
    </div>
  </form>
</template>

<script>
import modalContext    from "@/mixins/modalContext";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:    "IssueCompleteModal",
  mixins:  [modalContext, notifyHttpError],
  props:   ['onComplete'],
  data() {
    return {
      message:    '',
      error:      null,
      isProgress: false,
    };
  },
  methods: {
    onSubmit() {
      if (this.isProgress) return;
      this.error = this.message ? null : 'Поле обязательно для заполнения';
      if (this.error) return;

      this.isProgress = true;
      this.onComplete(this.message).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },
  },
};
</script>

<style scoped>

</style>
